import React, { useEffect, useMemo, useRef, useState } from "react";
import DataTable from "../../../components/common/datatable/DataTable";
import { useNavigate } from "react-router-dom";
import "../analyticsresults/AnalyticsResults.css";
import TopSection from "../TopSection";
import { analyticsResultsGETEndipoint, getViewAllDetailsEndpoint } from "../../../common/endpoints";
import { getAnalyticsWorkflowResults } from "../../../redux/actions/LTPlanner/AnalyticsWorkflowResultsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../components/common/Loader";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import LeadtimeModel from "../analyticsresults/LeadTimeModal";
import { DPSPlannerColumnHeader } from "./DPSPlannerColumnHeader";

const DPSPlannerAnalyticsResults = () => {
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const [rowData, setRowData] = useState([]);
    const gridRef = useRef();
    const currentPageRef = useRef(0);
    const [gridApi, setGridApi] = useState();
    const [openViewAllModal, setOpenViewAllModal] = useState(false);
    const [viewAllData, setViewAllData] = useState({});

    useEffect(() => {
        getWorkFlowData();
    }, [])
    useEffect(() => {
        const savedPage = localStorage.getItem("lastVisitedPage");
        if (savedPage !== null) {
            currentPageRef.current = Number(savedPage);
        }
    }, []);

    const getWorkFlowData = async () => {
        const userEmail = localStorage.getItem("data");
        try {
            const responseAnaltics = await dispatch(getAnalyticsWorkflowResults({
                dynamicEndpoint: `${analyticsResultsGETEndipoint}/${userEmail}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                },
            }));
            if (responseAnaltics?.meta?.requestStatus === 'fulfilled') {
                gridApi?.deselectAll();
                setRowData(responseAnaltics?.payload?.records?.[0]?.pendingActionItems);
            } else {
                console.error('Failed to fetch data:', responseAnaltics?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const navigate = useNavigate();

    const onGridReady = (params) => {
        setGridApi(params?.api);
    }

    const getViewAllData = async (row) => {
        try {
            const responseViewAllDetails = await dispatch(getViewAllDetails({
                dynamicEndpoint: `${getViewAllDetailsEndpoint}/${row.runSeqId}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
                setViewAllData(responseViewAllDetails?.payload)
            } else {
                console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
                setViewAllData({})
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }
    const handleOpenViewAllModal = (row) => {
        setOpenViewAllModal(true);
        getViewAllData(row);
    }
    const handleCloseViewAllModal = (row) => {
        setOpenViewAllModal(false);
        setViewAllData({})
    }

    const regularItemsData = DPSPlannerColumnHeader(navigate, handleOpenViewAllModal)

    const selectionColumnDef = useMemo(() => ({
        pinned: 'left'
    }))

    const gridOptions = {
        getRowId: (params) => {
            return `${params?.data?.runOutputSeqId}`
        },
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            sortable: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressMiniFilter: false,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            excelMode: 'windows',
                            suppressMiniFilter: false,
                            buttons: ['apply', 'reset'],
                        },
                    },
                ],
            },
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },
        }

    }

    const pagination = true;
    const paginationPageSize = 500;
    const paginationPageSizeSelector = [10, 50, 100, 500, 1000];

    const onPaginationChanged = () => {

        if (gridRef.current && !gridRef.current.isDestroyed()) {
            const currentPage = gridRef.current.paginationGetCurrentPage();
            currentPageRef.current = currentPageRef.current || currentPage;
            localStorage.setItem("lastVisitedPage", currentPage);
        }
    };
    const onFirstDataRendered = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            gridRef.current.paginationGoToPage(currentPageRef.current || 0);
            localStorage.setItem("lastVisitedPage", currentPageRef.current);
        }
    };

    return (
        (stateSelector?.AnalyticsWorkflowResultsSlice?.loading) ?
            <Loader />
            :
            <div>
                <TopSection tabTitle="DPS Analytics Results" labelList={[{ title: 'Home', path: '/landing-page' }, { title: 'DPS Analytics Results' }]} />
                <div
                    style={{
                        border: "1px solid lightgrey",
                        borderRadius: "6px",
                        padding: "10px",
                    }}
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {rowData &&
                            <div>
                                <DataTable
                                    ref={gridRef}
                                    columns={regularItemsData}
                                    rows={rowData || []}
                                    paginationProp={pagination}
                                    paginationPageSize={paginationPageSize}
                                    paginationPageSizeSelector={paginationPageSizeSelector}
                                    onGridReady={onGridReady}
                                    selectionColumnDef={selectionColumnDef}
                                    gridOptions={gridOptions}
                                    onPaginationChanged={onPaginationChanged}
                                    onFirstDataRendered={onFirstDataRendered}
                                />

                            </div>}
                        <div>
                            <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default DPSPlannerAnalyticsResults;
